module.exports = __webpack_public_path__ + "static/media/irish-charms.9d301498.gif";